+function ($) {

	"use strict";

	if (!$('body').hasClass('page-template-template-about-programs')) {
		return;
	}

	var history = new DbbHistoryState(true, window.appConfig.pagePathname);
	//history.setNativePushStateSupport(false);

	$(document).on('click', '[data-toggle="modal"]', function (event, disablePush) {
		var currentInstance = this;
		
		if (!disablePush) {
			var state = {
				'target' : $(this).data('target'),
				'href' : $(this).data('remote') || this.href
			};

			history.push(state, state.href, state.href.replace(window.appConfig.websiteBaseUrl + '/' + window.appConfig.websiteRelativePagePathname + '/', ''));
		}

		$($(this).data('target')).one('hide.bs.modal.program', function () {
			// We need to disable the video
			$($(currentInstance).data('target')).find('.modal-content').html('');
			
			history.push({}, 'default', '');
		});
	});

	$(window).on('onDbbHistoryStatePop', function () {
		if (history.getState() == null || $.isEmptyObject(history.getState())) {
			if (($('.modal:not(#videoModal)').is('visible')) || ($('.modal:not(#videoModal)').data('bs.modal'))) {
				$('.modal').find('.modal-content').html('');
				
				$('.modal').off('hide.bs.modal.program').modal('hide');
			}
			return;
		}

		var modal = $(history.getState().target);

		var ajaxLink = $('<a>').attr({
			'data-ajax-request': 'true',
			'href': history.getState().href
		});

		ajaxLink.appendTo(modal).trigger('click').remove();

		modal.modal('show');

		modal.one('loaded.ajax.html', function () {
			modal.trigger('resize');
		});
	});

	$(document).on('ready.program.modal', function () {

		var hash = window.location.hash.replace(/^(#!)/, '');

		if (hash != '') {
			var modalUrl = window.appConfig.websiteBaseUrl + '/' + window.appConfig.websiteRelativePagePathname + '/' + hash;

			$('a[href="' + modalUrl + '"]').addClass('load-on-page-request');
		}

		$('.load-on-page-request').each(function () {

			var state = {
				'target' : $(this).data('target'),
				'href' : $(this).data('remote') || this.href
			};

			history.replace(state, state.href, state.href.replace(window.appConfig.websiteBaseUrl + '/' + window.appConfig.websiteRelativePagePathname + '/', ''));

			$(this).trigger('click', true);
		});
	});

}(window.jQuery);
